import { useState } from 'react';
import { Button } from 'antd';

import { RawModal } from './RawModal';

export const RawAction = ({ snapId, id }: { snapId: number; id: number }) => {
  const [requestData, setRequestData] = useState<{ snapId: number; transactionId: number}>();

  return (
    <>
      <RawModal
        requestData={requestData}
        setRequestData={setRequestData}
      />

      <Button
        type='link'
        onClick={() => setRequestData({ snapId, transactionId: id })}
        className='p-0 mr-1'
      >
        View Raw
      </Button>
    </>
  );
};
